<script lang="ts">
import { lateinit } from 'tg-commons'
import { BaseMap, Heatmap, type HeatmapOptions } from 'tg-map-core'
import { defineComponent, watch } from 'vue'
import { createEmptyVNode, optionalProp, requiredProp, type Props } from '../../utils/vue-utils'
import { useTgMapInner } from '../map-hooks'

export default defineComponent({
  name: 'tg-heatmap',
  props: {
    maxIntensity: optionalProp(Number),
    gradient: optionalProp(Object),
    opacity: optionalProp(Number),
    radius: optionalProp(Number),
    data: requiredProp(Array as any),
  } satisfies Props<HeatmapOptions>,
  setup(props) {
    const { map, onCreate, onDestroy } = useTgMapInner<BaseMap>()
    let heatmap = lateinit<Heatmap>()

    onCreate(() => {
      heatmap = map.createHeatmap(props)
    })
    onDestroy(() => {
      heatmap.remove()
    })

    watch(() => props.data, (v) => heatmap.setData(v))
    watch(
      [() => props.maxIntensity, () => props.gradient, () => props.opacity, () => props.radius],
      () => heatmap.setOptions(props),
    )

    return createEmptyVNode
  },
})
</script>
